export default{
    data: function (){
        return {
            responsive: [ // definir no componente
                {
                    'breakpoint': 1920,
                    'settings': {
                        'cols': 4,
                        'rows': 3
                    }
                },
                {
                    'breakpoint': 100000,
                    'settings': {
                        'cols': 6,
                        'rows': 3
                    }
                },
                {
                    'breakpoint': 1366,
                    'settings': {
                        'cols': 2,
                        'rows': 2
                    }
                },
                {
                    'breakpoint': 1024,
                    'settings': {
                        'cols': 1,
                        'rows': 1
                    }
                },
                {
                    'breakpoint': 700,
                    'settings': {
                        'cols': 4,
                        'rows': 3,
                        'dots': false
                    }
                },
                {
                    'breakpoint': 500,
                    'settings': {
                        'cols': 3,
                        'rows': 2,
                        'dots': false
                    }
                },
                {
                    'breakpoint': 400,
                    'settings': {
                        'cols': 2,
                        'rows': 2,
                        'dots': false
                    }
                },
            ],
            windowWidth: 0,
            // cardList: [] // definir no componente
        }
    },
    computed: {
        responsiveOrderedByResolutionAsc() {
            let arrClone = JSON.parse(JSON.stringify(this.responsive)); // remove reatividade
            return arrClone.sort(this.arraySortAsc)
        },
        responsiveOrderedByResolutionDesc() {
            let arrClone = JSON.parse(JSON.stringify(this.responsive)); // remove reatividade
            return arrClone.sort(this.arraySortDesc)
        },
        breakpointMinLimit(){
            let vm = this;
            let res = this.responsiveOrderedByResolutionDesc.find(el => vm.windowWidth > el.breakpoint);

            return (res !== undefined) ? (res.breakpoint > 0 ? res.breakpoint+1 : 0) : 0;
        },
        breakpointMaxLimit(){
            let vm = this;
            let res = this.responsiveOrderedByResolutionAsc.find(el => vm.windowWidth <= el.breakpoint);

            return (res !== undefined) ? res.breakpoint : 1000000;
        },
        selectedBreakpoint(){
            let vm = this;
            let res = this.responsiveOrderedByResolutionDesc.find(el => vm.breakpointMaxLimit == el.breakpoint);
            return JSON.parse(JSON.stringify(res)); // remove responsividade
        },
        qtdCardsPerSlide() {
            return this.selectedBreakpoint.settings.rows*this.selectedBreakpoint.settings.cols;
        },
        slideArr(){
            let res = [];

            for (let i = 0; i < this.cardList.length; i = i+(this.qtdCardsPerSlide)) {
                res.push(this.cardList.slice(i,(i+this.qtdCardsPerSlide)));
            }
            return res;
        }

    },
    methods: {
        onResize() {
            let w = document.documentElement.clientWidth;
            if( w != this.windowWidth){
                this.windowWidth = w;
            }
        },
        arraySortAsc(a, b){
            return a.breakpoint - b.breakpoint;
        },
        arraySortDesc(a, b){
            return b.breakpoint-a.breakpoint;
        }
    },
    created(){
        this.onResize()
        window.addEventListener("resize", this.onResize);
    }
}



// WEBPACK FOOTER //
// ./resources/office/js/mixins/MultilineSlideGridH.js